module.exports = __webpack_public_path__ + "static/media/logo-agrobrasilia.93e18e32.png";